<template>
  <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }">
    <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }">
      <md-icon v-if="icon">{{ icon }}</md-icon>
      <label>
        {{ label }}
        <span v-if="required">&nbsp;*</span>
      </label>
      <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
      <md-input :value="value"
                @input="$emit('input', $event)"
                @keyup.enter="$emit('done', $event)"
                @keydown="isNumber($event)"
                @keyup="validateNumber($event.target._value)"
                type="text"
                :disabled="disabled"
                :readonly="readonly">
      </md-input>
      <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>
      <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
    </md-field>
    <span v-if="hasError" class="error-msg">{{regexError}}</span>
    <span v-else-if="failed" class="error-msg">{{errormsg}}</span>
  </ValidationProvider>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    dynamic: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    errormsg: {
      type: String,
      default: "Please enter a valid Australian phone number.",
    },
  },
  computed: {
    rules() {
      let rules = [];

      if(this.required) rules.push('required');

      return rules.join('|');
    },
  },
  data() {
    return {
      hasError: false,
      regexError: null,
    };
  },
  methods: {
    validateNumber(number){
      const regex = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/
      if(number.length > 0 && !regex.test(number)){
        this.hasError = true;
        this.regexError = "Please enter a valid Australian phone number."
      } else {
        this.hasError = false;
        this.regexError = null;
      }
    },
    isNumber: function(event) {
      event = (event) ? event : window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if (
          isNaN(event.key)
          && charCode != 8 //backspace
          && charCode != 9 //Tab
          && charCode != 37 //left-arrow
          && charCode != 39 //right-arrow
          && !(event.ctrlKey && charCode == 67) 		/* ctrl+c copy		*/
	      && !(event.ctrlKey && charCode == 86) 		/* ctrl+v paste			*/
	      && !(event.ctrlKey && charCode == 88) 		/* ctrl+x cut		*/
          && !(event.ctrlKey && charCode == 65) 		/* ctrl+a select all		*/
        ){
        event.preventDefault();
      } else {
        return true;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .disabled{
    opacity: 0.7;
  }
</style>
